module.exports = __webpack_public_path__ + "static/expert-3@2x-b55ef2569f6da3e35f5b1db57dc2d85a.png";